import { AlertTriangleIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Card, CardHeading } from '@/components/ui'
import { cn, formatNumber } from '@/utils'

interface SectionProps {
  title: string
  description: ReactNode
  count?: number
  children: ReactNode
  className?: string
}

export function Section({
  title,
  description,
  count,
  children,
  className,
}: SectionProps) {
  const hasFlags = count !== undefined && count > 0
  return (
    <Card className={cn('overflow-hidden', className)}>
      <CardHeading
        title={title}
        description={description}
        className="border-b"
        actions={
          count !== undefined && (
            <span
              className={cn(
                'inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 font-semibold text-xs',
                hasFlags
                  ? 'border border-red-200 bg-red-50 text-red-700'
                  : 'bg-blue-1 text-muted-foreground',
              )}
            >
              {hasFlags && <AlertTriangleIcon className="size-3" />}
              {formatNumber(count)} flagged
            </span>
          )
        }
      />
      {children}
    </Card>
  )
}
